import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@mui/material';
import { Radio } from '../../../form/radio/radio';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { SourceSurveyEnum } from '../../../../../defs/api';

export const SourceSurveyDialogContent: React.FC = observer(() => {
    const { t } = useTranslation();
    const { sourceSurveyStore } = useRootStore();

    const handleChooseOption = (event: React.ChangeEvent<HTMLInputElement>) => {
        sourceSurveyStore.setSource((event.target as HTMLInputElement).value as SourceSurveyEnum);
    };

    return (
        <div className="w-full rounded-[2.4rem] border border-border bg-transparent p-medium text-[var(--tariff-color)]">
            <RadioGroup name="reason" value={sourceSurveyStore.source} onChange={handleChooseOption}>
                <Radio label={t('dialogs.sourceSurvey.option.searchEngine')} value={SourceSurveyEnum.SearchEngine} />
                <Radio label={t('dialogs.sourceSurvey.option.kobeon')} value={SourceSurveyEnum.Kobeon} />
                <Radio label={t('dialogs.sourceSurvey.option.investown')} value={SourceSurveyEnum.Investown} />
                <Radio label={t('dialogs.sourceSurvey.option.advertisement')} value={SourceSurveyEnum.Advertisement} />
                <Radio label={t('dialogs.sourceSurvey.option.social')} value={SourceSurveyEnum.Social} />
                <Radio
                    label={t('dialogs.sourceSurvey.option.friendOrColleague')}
                    value={SourceSurveyEnum.FriendOrColleague}
                />
                <Radio label={t('dialogs.sourceSurvey.option.other')} value={SourceSurveyEnum.Other} />
            </RadioGroup>
        </div>
    );
});
